"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _AffiliateCountComponent = _interopRequireDefault(require("./AffiliateCountComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    affiliate: state.affiliate
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_AffiliateCountComponent["default"]);